<!-- Row 1 -->
<div class="no-action" *ngIf="notVerify"></div>
<div class="row px-3 pt-2 px-md-2">
  <div class="col-12 col-md-6 col-xl-4 p-0 pt-3 p-md-3">
    <div class="panel panel-default">
      <np-my-balance [allBalances]="allBalances"></np-my-balance>
    </div>
  </div>

  <div class="col-12 col-md-6 col-xl-4 p-0 pt-3 p-md-3" *ngIf="tradeCentre">
    <div class="panel panel-default">
      <np-fund-account></np-fund-account>
    </div>
  </div>

  <div class="col-12 col-md-6 col-xl-4 p-0 pt-3 p-md-3">
    <div class="panel panel-default">
      <np-payment-infomation [availableCurrencies]="availableCurrencies"></np-payment-infomation>
    </div>
  </div>

  <div class="col-12 col-md-6 col-xl-4 p-0 pt-3 p-md-3">
    <div class="panel panel-default">
      <np-my-outstanding-amount></np-my-outstanding-amount>
    </div>
  </div>

  <div class="col-12 col-xl-8 p-0 pt-3 p-md-3">
    <div class="panel panel-default">
      <np-future-history-trade></np-future-history-trade>
    </div>
  </div>
</div>